export function baseRoute({
  path,
  name,
  component,
  meta = {},
}) {
  return {
    path, name, component, meta,
  };
}

export function makeMetaRoute({
  moduleActive,
  subModuleActive,
  breadcrumbs,
  card,
  crud,
  groupName,
}) {
  return {
    moduleActive,
    subModuleActive,
    breadcrumbs,
    card,
    crud,
    groupName,
  };
}

export function buildListRoute({
  basePath,
  baseName,
  moduleActive,
  subModuleActive,
  baseBreadcrumbs,
  card,
  listRoute,
  moduleGroupName = '',
  component = () => import('Arch/components/crud/CrudListTemplate.vue'),
}) {
  return baseRoute({
    path: basePath,
    name: `${baseName}.list`,
    component,
    meta: makeMetaRoute({
      moduleActive,
      subModuleActive,
      breadcrumbs: baseBreadcrumbs,
      card,
      crud: listRoute,
      groupName: moduleGroupName,
    }),
  });
}

export function buildNewRoute({
  basePath,
  baseName,
  moduleActive,
  subModuleActive,
  baseBreadcrumbs,
  newRoute,
}) {
  return baseRoute({
    path: `${basePath}/new`,
    name: `${baseName}.new`,
    component: newRoute.component,
    meta: makeMetaRoute({
      moduleActive,
      subModuleActive,
      breadcrumbs: [
        ...baseBreadcrumbs,
        ...newRoute.breadcrumbs,
      ],
    }),
  });
}
export function buildEditRoute({
  basePath,
  baseName,
  moduleActive,
  subModuleActive,
  baseBreadcrumbs,
  editRoute,
}) {
  return baseRoute({
    path: `${basePath}/:id`,
    name: `${baseName}.edit`,
    component: editRoute.component,
    meta: makeMetaRoute({
      moduleActive,
      subModuleActive,
      breadcrumbs: [
        ...baseBreadcrumbs,
        ...editRoute.breadcrumbs,
      ],
    }),
  });
}

export function buildReplyRoute({
  basePath,
  baseName,
  moduleActive,
  subModuleActive,
  baseBreadcrumbs,
  replyRoute,
}) {
  return baseRoute({
    path: `${basePath}/reply`,
    name: `${baseName}.reply`,
    component: replyRoute.component,
    meta: {
      moduleActive,
      subModuleActive,
      breadcrumbs: [
        ...baseBreadcrumbs,
        ...replyRoute.breadcrumbs,
      ],
    },
  });
}

export function buildCrudRoutes({
  basePath,
  baseName,
  moduleActive,
  subModuleActive,
  baseBreadcrumbs,
  card,
  listRoute,
  newRoute,
  editRoute,
  replyRoute,
  moduleGroupName = '',
}) {
  const routes = [];
  if (replyRoute) {
    routes.push(
      buildReplyRoute({
        baseBreadcrumbs,
        baseName,
        basePath,
        moduleActive,
        replyRoute,
        subModuleActive,
      }),
    );
  }
  if (listRoute) {
    routes.push(buildListRoute({
      basePath,
      baseName,
      moduleActive,
      subModuleActive,
      baseBreadcrumbs,
      card,
      listRoute,
      moduleGroupName,
    }));
  }
  if (newRoute) {
    routes.push(buildNewRoute({
      basePath,
      baseName,
      moduleActive,
      subModuleActive,
      baseBreadcrumbs,
      newRoute,
    }));
  }
  if (editRoute) {
    routes.push(buildEditRoute({
      basePath,
      baseName,
      moduleActive,
      subModuleActive,
      baseBreadcrumbs,
      editRoute,
    }));
  }

  return routes;
}

export function buildChildModule({
  path,
  name,
  subModuleActive,
  editRoute,
  listRoute,
  newRoute,
  childrens = [],
  breadcrumbs,
  moduleActive,
  card,
  replyRoute,
  moduleGroupName = '',
  overrideChildProps = true,
}) {
  const routes = buildCrudRoutes({
    basePath: path,
    baseName: name,
    baseBreadcrumbs: breadcrumbs,
    moduleActive,
    card,
    subModuleActive,
    editRoute,
    listRoute,
    newRoute,
    replyRoute,
    moduleGroupName,
  });

  if (childrens && childrens.length) {
    if (overrideChildProps) {
      return [
        ...routes,
        ...childrens.map((child) => ({
          ...child,
          name: `${name}.${child.name}`,
          path: `${path}/${child.path}`,
        })),
      ];
    }
    return [
      ...routes,
      ...childrens,
    ];
  }

  return routes;
}

export function dois() {}
